var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full fixed justify-center block top-0 left-0 bg-white opacity-75 z-50"},[_c('div',{staticClass:"flex-none items-center opacity-75 top-1/2 my-auto mx-auto block relative w-16 h-16",attrs:{"role":"status"}},[_c('Spinner',{attrs:{"message":"Loading Data","size":16}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }